export const teamMembers = [
    {
      name: "Shivangi Dhyani",
      position: "Senior Attorney",
      image: require("../assests/Shivani.jpeg"),
      description:
        "With over 30 years of legal experience, Anil Dhyani is a renowned expert in corporate law, dispute resolution, and litigation. His leadership and strategic approach have set high standards in the legal industry.",
    },
    {
        name: "Ravinder Arya ",
        position: "Null",
        image: require("../assests/ravindra (2).jpeg"),
        description:
          "With over 30 years of legal experience, Anil Dhyani is a renowned expert in corporate law, dispute resolution, and litigation. His leadership and strategic approach have set high standards in the legal industry.",
      },
      {
        name: "Abhishek Saxena",
        position: "Null",
        image: require("../assests/adalogo.png"),
        description:
          "With over 30 years of legal experience, Anil Dhyani is a renowned expert in corporate law, dispute resolution, and litigation. His leadership and strategic approach have set high standards in the legal industry.",
      },
      {
        name: "Sourav chauhan",
        position: "Null",
        image: require("../assests/sourabh.jpeg"),
        description:
          "With over 30 years of legal experience, Anil Dhyani is a renowned expert in corporate law, dispute resolution, and litigation. His leadership and strategic approach have set high standards in the legal industry.",
      },
    
  ];
  